import { Fragment } from "react";
import classNames from "classnames";
import { Card, FormField } from "../elements/_Elements";
import { useFormReducer } from "./FormContext";
import {
  checkIfFieldDisabled,
  displayElement,
  getFieldLabel,
  getFieldValue,
  getLookupFieldOptions,
} from "./Helpers";
import { useGlobalState } from "../../GlobalContext";
import { checkIfDynamicContentItemSelected } from "./communication/Helpers";

function SidebarForm({
  activeTab,
  errors,
  handleBlur,
  handleChange,
  handleCheckListChange,
  handleFilteredPicklistChange,
  handlePicklistChange,
  setFieldValue,
  selectedDynamicContentItemIndex,
  stages,
  state,
  touched,
  useTabs,
  values,
}) {
  const dispatch = useFormReducer();
  const globalState = useGlobalState();
  let editingDynamicContent = checkIfDynamicContentItemSelected(
    selectedDynamicContentItemIndex
  );
  let displayedValues = editingDynamicContent
    ? values.dynamicContentItemsValuesArray[
        selectedDynamicContentItemIndex
      ]
    : values;

  return (
    <>
      {stages.map((stage, stageIndex) => {
        const { sections } = stage;
        const fieldSections = sections.filter(
          (section) => section.fields
        );
        return (
          <Fragment key={stageIndex}>
            {fieldSections
              .filter((field) =>
                displayElement(
                  field,
                  state,
                  displayedValues,
                  globalState
                )
              )
              .map((section, sectionIndex) => {
                // render a Fragment instead of Card if wrapInCard is set to false
                const { wrapInCard } = section;
                const CardComponent =
                  typeof wrapInCard !== "undefined" &&
                  wrapInCard === false
                    ? Fragment
                    : Card;

                return (
                  <div
                    key={sectionIndex}
                    className={classNames(
                      "mb-3",
                      useTabs && activeTab !== stage.title
                        ? "d-none"
                        : ""
                    )}
                  >
                    <CardComponent>
                      <div className="row g-3">
                        {section.renderHeader ? (
                          section.renderHeader(
                            dispatch,
                            section,
                            displayedValues
                          )
                        ) : section.name ? (
                          <div className="col-12">
                            <h5 className="d-inline-block">
                              {section.name}
                            </h5>
                          </div>
                        ) : (
                          <></>
                        )}
                        {section.fields
                          .filter((field) =>
                            displayElement(
                              field,
                              state,
                              displayedValues,
                              globalState
                            )
                          )
                          .map((field, fieldsIndex) => {
                            return (
                              <div
                                key={fieldsIndex}
                                className={
                                  field.className
                                    ? field.className
                                    : "col-12"
                                }
                              >
                                <FormField
                                  {...{
                                    field,
                                    handleBlur,
                                    handleCheckListChange,
                                    handlePicklistChange,
                                    setFieldValue,
                                    state,
                                    touched,
                                    displayedValues,
                                  }}
                                  description={field.description}
                                  disabled={
                                    field.disabled ||
                                    checkIfFieldDisabled(
                                      field,
                                      state,
                                      displayedValues
                                    )
                                  }
                                  errors={
                                    errors ? errors[field.name] : null
                                  }
                                  handleChange={(event) => {
                                    handleChange(event, field.name);
                                  }}
                                  handleFilteredPicklistChange={(
                                    event
                                  ) =>
                                    handleFilteredPicklistChange(
                                      event,
                                      handleChange,
                                      field.name,
                                      displayedValues
                                    )
                                  }
                                  handleRichTextEditorChange={(
                                    newContent
                                  ) => {
                                    if (editingDynamicContent) {
                                      let updatedValues =
                                        values.dynamicContentItemsValuesArray;
                                      updatedValues[
                                        selectedDynamicContentItemIndex
                                      ][field.name] = newContent;
                                      setFieldValue(
                                        "dynamicContentItemsValuesArray",
                                        updatedValues
                                      );
                                    } else {
                                      setFieldValue(
                                        field.name,
                                        newContent
                                      );
                                    }
                                  }}
                                  label={getFieldLabel(
                                    field,
                                    state,
                                    displayedValues
                                  )}
                                  mandatory={field.mandatory}
                                  options={getLookupFieldOptions(
                                    field,
                                    state,
                                    displayedValues,
                                    null
                                  )}
                                  optionsEnum={field.enum}
                                  value={getFieldValue(
                                    field,
                                    displayedValues
                                  )}
                                  values={displayedValues}
                                />
                              </div>
                            );
                          })}
                      </div>
                    </CardComponent>
                  </div>
                );
              })}
          </Fragment>
        );
      })}
    </>
  );
}

export default SidebarForm;
